import React from 'react'
import { shallow } from 'enzyme'

import LinkModal from '../../features/TextEditor/LinkModal'
import CloseIcon from '../../../common/icons/CloseIcon2'
import BlueLoadingButton from '../../../common/BlueLoadingButton'

describe('LinkModal', () => {
  let wrapper, props, instance
  beforeEach(() => {
    props = {
      editorState: null,
      toggleModal: jest.fn(),
      updateEditorState: jest.fn(),
    },
    wrapper = shallow(<LinkModal {...props} />)
    instance = wrapper.instance()
  })
  it('should have close Icon by default', () => {
    const closeIcon = wrapper.find(CloseIcon).at(0)
    expect(closeIcon).toHaveLength(1)
  })
  it('should have BLue loading bugtton by default', () => {
    const blueButton = wrapper.find(BlueLoadingButton).at(0)
    expect(blueButton).toHaveLength(1)
  })
  describe('#formatLink', () => {
    it('should format the link by adding http://', () => {
      const link = 'www.google.com'
      expect(instance.formatLink(link)).toBe('http://www.google.com')
    })
  })
  describe('#isValid', () => {
    it('should check if the linkText and url valid as false', () => {
      expect(instance.isValid()).toBeFalsy()
    })
  })
  describe('#onUrlChange', () => {
    it('should change the linkText state', () => {
      const event = { target: { value: 'http://www.google.com' } }
      instance.onUrlChange(event)
      expect(wrapper.state('url')).toBe(event.target.value)
    })
  })
  describe('#onLinkTextChange', () => {
    it('should change the linkText state', () => {
      const event = { target: { value: 'Content'}}
      instance.onLinkTextChange(event)
      expect(wrapper.state('linkText')).toBe(event.target.value)
    })
  })
  describe('#onSubmit', () => {
    it('should call onLinkCreate method', () => {
      const onLinkCreate = spyOn(instance, 'onLinkCreate')
      instance.onSubmit()
      expect(onLinkCreate).toHaveBeenCalledTimes(1)
      expect(props.toggleModal).toHaveBeenCalledTimes(1)
    })
  })
  describe('#render', () => {
    describe('when close button is clicked', () => {
      it('should call props toggleModal method', () => {
        const closeIcon = wrapper.find('LinkModal__CloseButton').at(0)
        closeIcon.simulate('click')
        expect(props.toggleModal).toHaveBeenCalledTimes(1)
      })
    })
    describe('when Cancel button is clicked', () => {
      it('should call toggleModal method', () => {
        const cancelBtn = wrapper.find('LinkModal__Cancel').at(0)
        cancelBtn.simulate('click')
        expect(props.toggleModal).toHaveBeenCalledTimes(1)
      })
    })
  })

})